export default "__VITE_ASSET__8a679c67__"